import axios from 'axios';
import Utils from "../utils";
import EventBus from "../plugins/event-bus";

axios.interceptors.request.use((config) => {
    let checkUserId = config?.optionsConfig?.checkUserId !== undefined ? config?.optionsConfig?.checkUserId : true
    if (config.url && (config.url.indexOf('cloudhub.io') !== -1) && !Utils.loadUserId() && checkUserId) {
        EventBus.$emit('logout');
        throw new axios.Cancel(EventBus.getTranslateMessage('sessaoExpirada'));
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});

export default axios;